/*
  Toorx Professional – Anfrageliste
  Kein Warenkorb: Geräte werden im Browser gemerkt (localStorage) und auf /pages/anfrage
  zusammen mit dem Kontaktformular gesendet. Schnittstelle: window.TxAnfrage.
*/
(function () {
  const SCHLUESSEL = 'tx-anfrage-v1';
  let speicherOk = true;
  let notListe = []; // falls der Browser keinen Speicher erlaubt (z. B. privates Fenster)

  function lesen() {
    try {
      if (!speicherOk) return notListe;
      const roh = localStorage.getItem(SCHLUESSEL);
      const liste = roh ? JSON.parse(roh) : [];
      return Array.isArray(liste) ? liste : [];
    } catch (e) {
      speicherOk = false;
      return notListe;
    }
  }

  function schreiben(liste) {
    notListe = liste;
    try {
      if (speicherOk) localStorage.setItem(SCHLUESSEL, JSON.stringify(liste));
    } catch (e) {
      speicherOk = false;
    }
    aktualisiereZaehler();
    document.dispatchEvent(new CustomEvent('tx:anfrage', { detail: { liste } }));
  }

  function anzahl(liste) {
    return (liste || lesen()).reduce((summe, eintrag) => summe + (eintrag.menge || 1), 0);
  }

  function aktualisiereZaehler() {
    const n = anzahl();
    document.querySelectorAll('[data-tx-zaehler]').forEach((el) => {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  // Gewählte Ausführung (Farbe, Gewicht, Größe …): Dawn-Variantenauswahl, sonst ?variant= in der Adresse, sonst Vorauswahl
  function gewaehlteVariante(el) {
    let varianten;
    try {
      varianten = JSON.parse(el.dataset.varianten || 'null');
    } catch (e) {
      varianten = null;
    }
    if (!Array.isArray(varianten) || !varianten.length) return null;
    let id = null;
    const ausgewaehlt = document.querySelector('variant-selects [data-selected-variant]');
    if (ausgewaehlt) {
      try {
        id = (JSON.parse(ausgewaehlt.textContent) || {}).id;
      } catch (e) {
        id = null;
      }
    }
    if (!id) id = new URLSearchParams(location.search).get('variant');
    if (!id) id = el.dataset.variante;
    return varianten.find((v) => String(v.id) === String(id)) || varianten[0];
  }

  function ausElement(el) {
    const eintrag = {
      handle: el.dataset.handle,
      schluessel: el.dataset.handle,
      titel: el.dataset.titel,
      bild: el.dataset.bild || '',
      url: el.dataset.url || '',
    };
    const variante = gewaehlteVariante(el);
    if (variante) {
      eintrag.schluessel = el.dataset.handle + '#' + variante.id;
      eintrag.titel = el.dataset.titel + ' – ' + variante.titel + (variante.sku ? ' (Art.-Nr. ' + variante.sku + ')' : '');
      if (eintrag.url) eintrag.url += (eintrag.url.indexOf('?') < 0 ? '?' : '&') + 'variant=' + variante.id;
    }
    return eintrag;
  }

  function schluessel(eintrag) {
    return eintrag.schluessel || eintrag.handle;
  }

  const TxAnfrage = {
    liste: lesen,
    anzahl: () => anzahl(),
    hinzufuegen(eintrag, menge = 1) {
      if (!eintrag || !eintrag.handle) return;
      const liste = lesen();
      const vorhanden = liste.find((e) => schluessel(e) === schluessel(eintrag));
      if (vorhanden) vorhanden.menge = (vorhanden.menge || 1) + menge;
      else liste.push(Object.assign({}, eintrag, { menge }));
      schreiben(liste);
    },
    setzeMenge(handle, menge) {
      let liste = lesen();
      if (menge <= 0) liste = liste.filter((e) => schluessel(e) !== handle);
      else liste.forEach((e) => { if (schluessel(e) === handle) e.menge = menge; });
      schreiben(liste);
    },
    leeren() {
      schreiben([]);
    },
    alsText() {
      return lesen()
        .map((e) => `${e.menge || 1} × ${e.titel}${e.url ? ' (' + location.origin + e.url + ')' : ''}`)
        .join('\n');
    },
  };
  window.TxAnfrage = TxAnfrage;

  document.addEventListener('click', (ereignis) => {
    const knopf = ereignis.target.closest('[data-tx-add]');
    if (knopf) {
      ereignis.preventDefault();
      TxAnfrage.hinzufuegen(ausElement(knopf));
      knopf.classList.add('ist-drin');
      clearTimeout(knopf._txTimer);
      knopf._txTimer = setTimeout(() => knopf.classList.remove('ist-drin'), 2200);
      return;
    }
    const direkt = ereignis.target.closest('[data-tx-direkt]');
    if (direkt) {
      const liste = lesen();
      const eintrag = ausElement(direkt);
      if (!liste.some((e) => schluessel(e) === schluessel(eintrag))) TxAnfrage.hinzufuegen(eintrag);
    }
  });

  window.addEventListener('storage', (e) => { if (e.key === SCHLUESSEL) aktualisiereZaehler(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aktualisiereZaehler);
  else aktualisiereZaehler();
})();
